export const SET_CASHOUT_DATA = '[APP] Set Cashout Data';
export const SET_CASHOUT_LOADING = '[APP] Set Cashout Loading';
export const RESET_CASHOUT_DATA = '[APP] Reset Cashout Data';
export const SET_CASHOUT_SUCCESS = '[APP] Set Cashout Success';
